// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import { photoclammetry } from './photoclammetry.js';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});
